import { memo, useEffect, useState, useRef } from "react"

import ProductService from "@/services/product"
import { Stack, Text, Image, AspectRatio, Center, Button, Container, Box, Table, Card, VStack, HStack, Separator, Flex, Badge } from "@chakra-ui/react"
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { LuPencil } from "react-icons/lu"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import WithLoginPage from "@/components/withlogin"
import OrderService from "services/order"
import CartService from "services/cart"
import { useNavigate, useParams } from "react-router"
import { LuMessageCircle } from "react-icons/lu"
import { useStore } from "contexts/store";
import { useChat } from "contexts/chat";
import ImagePreview from "@/components/image-preview";
const service = new OrderService();

const Cart = () => {
    const { setProcessing, setPageTitle, showToast, showConfirm, printPdf } = useApp();

    const { reby } = useCart();
    const navigate = useNavigate();

    const [order, setOrder] = useState({})
    const { id } = useParams();
    const { store } = useStore();
    const { openChat, hasChatEntry } = useChat();
    const canCancel = (order.payment_status?.id == "unpaid" && order.shipping_status?.id == "not_shipped" && order.internal_status?.id == "pending");
    const canPay = (order.status != "canceled" && order.status != "finalized" && order.payment_status?.id == "unpaid");

    const getStatus = () => {
        if (order.status == "canceled") {
            return { label: "Đã huỷ", color: "red" };
        }
        if (order.status == "finalized") {
            return { label: "Đã hoàn tất", color: "green" };
        }
        return { label: order.payment_status?.title || "Đang xử lý", color: "orange" };
    };

    const status = getStatus();

    const visibleNotes = [...(Array.isArray(order.note_timeline) ? order.note_timeline : [])]
        .filter((x) => x?.show_to_customer)
        .sort((a, b) => new Date(b?.create_on || 0).getTime() - new Date(a?.create_on || 0).getTime());

    const invoiceInfo = order?.invoice_info || order?.shipping_address?.invoice_info || {};
    const hasInvoiceInfo = !!invoiceInfo && Object.values(invoiceInfo).some((value) => {
        if (typeof value === 'string') return value.trim().length > 0;
        return !!value;
    });
    const taxPercent = Number(order?.tax_percent ?? invoiceInfo?.tax_percent ?? 0);

    const formatNoteTime = (value) => {
        if (!value) {
            return "";
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
            return "";
        }
        return date.toLocaleString("vi-VN");
    };

    useEffect(() => {
        setPageTitle("Chi tiết đơn hàng")
    }, [setPageTitle])

    useEffect(() => {
        loadData();

    }, [id])

    const loadData = async () => {
        setProcessing(true)
        var data = await service.get(id);
        if (data) {
            setOrder(data);
        }
        setProcessing(false)
    }












    const downloadPDF = async () => {
        try {
            var url = order.invoice_file;
            var filename = order.id + ".pdf";
            // Fetch the PDF data as a Blob
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a download link and set its attributes
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;

            // Append the link to the document, click it, and remove it
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error while downloading PDF:', error);
        }
    }


    const downLoadInvoiceFile = async () => {
        setProcessing(true)
        console.log("order ", order)
        var data = await service.createInvoiceFile({ id: order.id });
        setProcessing(false);
        if (data) {
            printPdf(data.invoice_file)
            // window.location = data.invoice_file;
        }

    }

    const reByClick = async () => {
        showConfirm({ title: "Mua lại đơn hàng?", message: "Tất cả các sản phẩm này sẽ được thêm vào giỏ hàng.", onOk: e => onRebyConfirm() })
    }

    const cancelOrderClick = async () => {
        showConfirm({ title: "Huỷ đơn hàng", message: "Bạn chắc chắn muốn huỷ đơn hàng này?", onOk: e => onCancelConfirm() })
    }



    const onRebyConfirm = async () => {
        await reby(order.id)
        showToast({
            description: `Giỏ hàng đã được cập nhật`, type: "success",
            duration: 6000,
            action: {
                label: "Xem giỏ hàng",
                onClick: () => navigate("/cart"),
            }
        });


    }


    const onCancelConfirm = async () => {
        setProcessing(true);
        try {
            await service.cancel({ id: order.id });

        } catch (error) {

        }

        await loadData();
        setProcessing(false);
        showToast({
            description: `Đơn hàng đã được huỷ`, type: "success",
            duration: 6000,

        });
        // await reby(order.id)
        // showToast({
        //     description: `Giỏ hàng đã được cập nhật`, type: "success",
        //     duration: 6000,
        //     action: {
        //         label: "Xem giỏ hàng",
        //         onClick: () => navigate("/cart"),
        //     }
        // });


    }







    return (
        <div style={{ paddingBottom: canPay ? 135 : 95 }}>

            <div >


                <Stack gap="3" align="stretch" maxW="sm">






                    <Card.Root size="sm">
                        <Card.Body>
                            <Stack gap={2}>
                                <HStack justify="space-between">
                                    <Text fontWeight="bold">Mã đơn: {order.id}</Text>
                                    <Badge colorPalette={status.color}>{status.label}</Badge>
                                </HStack>
                                <Text color="fg.muted">Sản phẩm: {order.total_item || 0}</Text>
                            </Stack>
                        </Card.Body>
                    </Card.Root>

                    <Card.Root size="sm">
                        <Card.Body>
                            <Stack gap={1}>
                                <Text fontWeight="bold">Địa chỉ giao hàng</Text>
                                <Text><Text as="span" color="fg.muted">Người nhận: </Text>{order.shipping_address?.full_name || "-"}</Text>
                                <Text><Text as="span" color="fg.muted">Số điện thoại: </Text>{order.shipping_address?.phone_number || "-"}</Text>
                                <Text><Text as="span" color="fg.muted">Địa chỉ: </Text>{order.shipping_address?.address || "-"}</Text>
                            </Stack>
                        </Card.Body>
                    </Card.Root>

                    {hasInvoiceInfo && (
                        <Card.Root size="sm">
                            <Card.Body>
                                <Stack gap={2}>
                                    <HStack justify="space-between" align="start">
                                        <Text fontWeight="bold">Thông tin hoá đơn</Text>
                                        <Button size="xs" variant="ghost" onClick={() => navigate("/profile/edit")}>Chỉnh sửa</Button>
                                    </HStack>
                                    {invoiceInfo.company_name && <Text><Text as="span" color="fg.muted">Tên công ty: </Text>{invoiceInfo.company_name}</Text>}
                                    {invoiceInfo.tax_number && <Text><Text as="span" color="fg.muted">Mã số thuế: </Text>{invoiceInfo.tax_number}</Text>}
                                    {invoiceInfo.address && <Text><Text as="span" color="fg.muted">Địa chỉ: </Text>{invoiceInfo.address}</Text>}
                                    {invoiceInfo.email && <Text><Text as="span" color="fg.muted">Email: </Text>{invoiceInfo.email}</Text>}
                                    {invoiceInfo.note && <Text><Text as="span" color="fg.muted">Ghi chú: </Text>{invoiceInfo.note}</Text>}
                                </Stack>
                            </Card.Body>
                        </Card.Root>
                    )}



                    {(order.line_items ?? []).map((item) => (
                        <Card.Root key={item.id || `${item.product_id}-${item.variant?.id}`} size="sm">
                            <Card.Body>
                                <HStack align="start" gap={3}>
                                    <Box width="28%" minW="90px">
                                        <AspectRatio ratio={4 / 3}>
                                            <Center>
                                                <Image src={item.variant?.images?.[0]?.url ?? item.product?.thumbnail?.url}></Image>
                                            </Center>
                                        </AspectRatio>
                                    </Box>
                                    <Stack gap={1} flex="1">
                                        <Text fontWeight="semibold" lineClamp={2}>{item.product?.name}</Text>
                                        <Text color="fg.muted" fontSize="sm">{item.variant?.variant_title || "Mặc định"}</Text>
                                        <HStack justify="space-between">
                                            <Text color="fg.muted">SL: {item.quantity || 0}</Text>
                                            <Text color="fg.muted">Đơn giá: {formatCurrency(item.price)}</Text>
                                        </HStack>
                                        <HStack justify="space-between">
                                            <Text color="fg.muted">Thành tiền</Text>
                                            <Text fontWeight="bold">{formatCurrency(item.amount)}</Text>
                                        </HStack>
                                    </Stack>
                                </HStack>
                            </Card.Body>
                        </Card.Root>

                    ))
                    }

                    <Card.Root size="sm">
                        <Card.Body>
                            <Table.Root size="sm">

                                <Table.Body style={{ fontWeight: "500" }}>

                                    <Table.Row >
                                        <Table.Cell>Thành tiền</Table.Cell>
                                        <Table.Cell textAlign="end">{formatCurrency(order.sub_amount)}</Table.Cell>
                                    </Table.Row>

                                    <Table.Row >
                                        <Table.Cell>Giảm giá</Table.Cell>
                                        <Table.Cell textAlign="end">{formatCurrency(order.discount_amount)}
                                        </Table.Cell>

                                    </Table.Row>
                                    {order.voucher_code &&
                                        <Table.Row >
                                            <Table.Cell>Mã giảm giá {order.voucher_code} </Table.Cell>
                                            <Table.Cell textAlign="end">{formatCurrency(order.voucher_amount)}
                                            </Table.Cell>
                                        </Table.Row>
                                    }

                                    {(order.point_discount > 0) &&
                                        <Table.Row >
                                            <Table.Cell>Xu </Table.Cell>
                                            <Table.Cell textAlign="end">{formatCurrency(order.point_discount)}
                                            </Table.Cell>
                                        </Table.Row>
                                    }





                                    <Table.Row >
                                        <Table.Cell>Phí ship</Table.Cell>
                                        <Table.Cell textAlign="end">
                                            {order.shipping_amount == 0 ? 'Trả sau' : formatCurrency(order.shipping_amount)}



                                        </Table.Cell>
                                    </Table.Row>

                                    {hasInvoiceInfo && (
                                        <Table.Row >
                                            <Table.Cell>Thuế xuất{taxPercent > 0 ? ` (${taxPercent}%)` : ""}</Table.Cell>
                                            <Table.Cell textAlign="end">{formatCurrency(Number(order.tax_amount ?? 0))}</Table.Cell>
                                        </Table.Row>
                                    )}
                                    {/* <Table.Row >
                                <Table.Cell>Vận chuyển bởi</Table.Cell>
                                <Table.Cell textAlign="end">Phương Trang Express</Table.Cell>
                            </Table.Row> */}

                                    <Table.Row >
                                        <Table.Cell>Tổng tiền</Table.Cell>
                                        <Table.Cell textAlign="end">
                                            {formatCurrency(order.total_amount)}</Table.Cell>
                                    </Table.Row>

                                    <Table.Row >
                                        <Table.Cell>Đã thanh toán</Table.Cell>
                                        <Table.Cell textAlign="end">
                                            {formatCurrency(order.payment_amount)}</Table.Cell>
                                    </Table.Row>

                                    {/* <Table.Row >
                                <Table.Cell>Còn lại</Table.Cell>
                                <Table.Cell textAlign="end">
                                    {formatCurrency(order.remain_amount)}</Table.Cell>
                            </Table.Row> */}

                                </Table.Body>
                            </Table.Root>
                        </Card.Body>
                    </Card.Root>

                    {visibleNotes.length > 0 && (
                        <Card.Root size="sm">
                            <Card.Body>
                                <Stack gap={3}>
                                    <Text fontWeight="bold">Ghi chú từ cửa hàng</Text>
                                    {visibleNotes.map((note) => (
                                        <Box key={note?.id} borderWidth="1px" borderRadius="md" p={3}>
                                            {!!note?.content && <Text>{note.content}</Text>}

                                            {Array.isArray(note?.images) && note.images.length > 0 && (
                                                <Flex gap={2} mt={2} wrap="wrap">
                                                    {note.images.map((img, idx) => (
                                                        <ImagePreview
                                                            key={`${note?.id || "note"}-${idx}`}
                                                            src={img?.url}
                                                            alt={`note-image-${idx + 1}`}
                                                            imageProps={{
                                                                boxSize: "72px",
                                                                objectFit: "cover",
                                                                borderRadius: "md"
                                                            }}
                                                        />
                                                    ))}
                                                </Flex>
                                            )}

                                            {!!formatNoteTime(note?.create_on) && (
                                                <Text color="fg.muted" fontSize="xs" mt={2}>{formatNoteTime(note?.create_on)}</Text>
                                            )}
                                        </Box>
                                    ))}
                                </Stack>
                            </Card.Body>
                        </Card.Root>
                    )}




                    <VStack style={{ width: "100%" }}>

                        <Button onClick={downLoadInvoiceFile} variant={"ghost"}>Tải xuống hoá đơn</Button>

                        <Button onClick={reByClick} variant={"ghost"}>Mua lại</Button>
                        {canCancel &&
                            <Button onClick={cancelOrderClick} variant={"ghost"}>Huỷ đơn hàng</Button>
                        }

                        {/* <Button onClick={e => navigate("/order-list")} variant={"ghost"}>Mua lại</Button> */}
                    </VStack>


                    <Center>
                        Xin chân thành cám ơn và rất hân hạnh phục vụ quý khách.
                    </Center>




                </Stack>



            </div>


            <Container maxW={"md"} style={{ position: "fixed", bottom: 0, left: 0, right: 0, backgroundColor: "white", padding: 0 }}>
                <Box bg="bg" shadow="md" borderRadius="md" style={{ padding: 8 }}>


                    <Flex gap="4" justifyContent={"center"} flexDirection={"column"}>

                        {canPay && (
                            <Button variant={"solid"} onClick={e => navigate("/order-pay/" + order.id)}  >
                                Thanh toán
                            </Button>
                        )}

                        {hasChatEntry &&
                            <Button
                                variant={"outline"}
                                onClick={e => openChat({
                                    chatAttachment: {
                                        type: "order",
                                        title: `Đơn hàng #${order?.id}`,
                                        meta: { order_id: order?.id },
                                    }
                                })}
                            >
                                Hỗ trợ xử lý đơn hàng    <LuMessageCircle></LuMessageCircle>
                            </Button>
                        }


                    </Flex>
                </Box>
            </Container>
        </div >
    )
}


const withLogin = () => (<WithLoginPage><Cart></Cart></WithLoginPage>)


export default memo(withLogin)

